import React, { Component } from "react";
import { Link } from 'react-router-dom';
class NextPrev extends Component {
  render() {
    const { handleNextAction, handlePrevAction, prev, next } = this.props;
    return (
        <div className="sec-btn">
            {
                prev > 1 &&
                <Link to="#" onClick={handlePrevAction} className="btn-img">
                    <img src={require("./../../../assets/img/icons/ic-prev.png")} alt=""/>
                </Link>
            }
            {
                next !==0 &&
                <Link to="#" onClick={handleNextAction} className="btn-img">
                    <img src={require("./../../../assets/img/icons/ic-next.png")} alt=""/>
                </Link>
            }
        </div>
    );
  }
}

export default NextPrev;
